(() => {
  if (window.ProductJourneyTimeline) {
    window.ProductJourneyTimeline.init(document);
    return;
  }

  const instances = new WeakMap();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

  const initSection = (section) => {
    if (!section || instances.has(section)) return;

    const milestones = Array.from(section.querySelectorAll('[data-product-journey-milestone]'));
    const list = section.querySelector('[data-product-journey-list]');

    if (!list || !milestones.length) return;

    const update = () => {
      const triggerOffset = clamp(window.innerHeight * 0.28, 110, 200);
      const triggerPoint = window.innerHeight - triggerOffset;
      let currentIndex = 0;

      milestones.forEach((milestone, index) => {
        if (milestone.getBoundingClientRect().bottom <= triggerPoint) currentIndex = index;
      });

      milestones.forEach((milestone, index) => {
        const control = milestone.querySelector('[data-product-journey-step]');
        const isCurrent = index === currentIndex;
        const isComplete = index < currentIndex;

        milestone.classList.toggle('is-current', isCurrent);
        milestone.classList.toggle('is-complete', isComplete);
        milestone.classList.toggle('is-active', isCurrent);

        if (control) {
          if (isCurrent) {
            control.setAttribute('aria-current', 'step');
          } else {
            control.removeAttribute('aria-current');
          }
        }
      });
    };

    let frame;
    const requestUpdate = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(() => {
        frame = undefined;
        update();
      });
    };

    section.querySelectorAll('[data-product-journey-step]').forEach((control) => {
      control.addEventListener('click', () => {
        const milestone = control.closest('[data-product-journey-milestone]');
        if (!milestone) return;
        milestone.scrollIntoView({
          behavior: reducedMotion ? 'auto' : 'smooth',
          block: 'center',
        });
      });
    });

    section.querySelectorAll('[data-product-journey-scroll]').forEach((button) => {
      button.addEventListener('click', (event) => {
        const productForm = document.querySelector('form[action*="/cart/add"]');
        if (!productForm) return;
        event.preventDefault();
        productForm.scrollIntoView({
          behavior: reducedMotion ? 'auto' : 'smooth',
          block: 'center',
        });
        const focusTarget = productForm.querySelector('input, select, button');
        if (focusTarget) focusTarget.focus({ preventScroll: true });
      });
    });

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    update();

    instances.set(section, {
      destroy() {
        window.removeEventListener('scroll', requestUpdate);
        window.removeEventListener('resize', requestUpdate);
        if (frame) window.cancelAnimationFrame(frame);
      },
    });
  };

  const init = (scope = document) => {
    if (scope.matches && scope.matches('[data-product-journey]')) initSection(scope);
    scope.querySelectorAll?.('[data-product-journey]').forEach(initSection);
  };

  const destroy = (scope = document) => {
    const sections = [];
    if (scope.matches && scope.matches('[data-product-journey]')) sections.push(scope);
    scope.querySelectorAll?.('[data-product-journey]').forEach((section) => sections.push(section));
    sections.forEach((section) => {
      const instance = instances.get(section);
      if (!instance) return;
      instance.destroy();
      instances.delete(section);
    });
  };

  window.ProductJourneyTimeline = { init, destroy };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroy(event.target));
})();
